<span class="w-2 h-2 rounded-full ml-(--space-2)" [class]="class" [title]="title">&nbsp;</span>
